var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRankify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 44,
    viewBox: "0 0 134 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.192 25.7881L39.067 43.9272H15.6561L3.9506 29.3576L20.192 25.7881Z",
    fill: "url(#paint0_linear_1056_14460)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4846 29.1391C28.5655 29.1391 35.1164 22.6161 35.1164 14.5695C35.1164 6.523 28.5655 0 20.4846 0H0L12.0713 17.2649L20.4846 29.1391Z",
    fill: "url(#paint1_linear_1056_14460)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2085 43.748C22.3259 43.9135 21.4154 44 20.4846 44H0V29.1391H10.2423L23.2085 43.748Z",
    fill: "url(#paint2_linear_1056_14460)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2085 28.8871C22.3259 29.0525 21.4154 29.1391 20.4846 29.1391H0L0.0387374 14.6424L0 0L23.2085 28.8871Z",
    fill: "url(#paint3_linear_1056_14460)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6266 26.8886C39.6266 25.1992 39.9602 23.7009 40.6274 22.3936C41.3148 21.0864 42.2347 20.0808 43.3871 19.3769C44.5598 18.673 45.8638 18.321 47.2993 18.321C48.5528 18.321 49.6445 18.5724 50.5745 19.0752C51.5248 19.578 52.2829 20.2115 52.849 20.9757V18.5925H57.1251V35.3054H52.849V32.8618C52.3032 33.6462 51.545 34.2998 50.5745 34.8227C49.6243 35.3255 48.5224 35.5769 47.2689 35.5769C45.8537 35.5769 44.5598 35.2149 43.3871 34.4909C42.2347 33.7668 41.3148 32.7512 40.6274 31.4439C39.9602 30.1166 39.6266 28.5981 39.6266 26.8886ZM52.849 26.9489C52.849 25.9232 52.6469 25.0484 52.2425 24.3244C51.8382 23.5802 51.2923 23.0171 50.6049 22.635C49.9175 22.2327 49.1795 22.0316 48.391 22.0316C47.6025 22.0316 46.8747 22.2227 46.2075 22.6048C45.5403 22.9869 44.9944 23.5501 44.5699 24.2942C44.1655 25.0182 43.9633 25.883 43.9633 26.8886C43.9633 27.8942 44.1655 28.7791 44.5699 29.5434C44.9944 30.2875 45.5403 30.8607 46.2075 31.2629C46.8949 31.6652 47.6227 31.8663 48.391 31.8663C49.1795 31.8663 49.9175 31.6752 50.6049 31.2931C51.2923 30.8909 51.8382 30.3277 52.2425 29.6037C52.6469 28.8596 52.849 27.9746 52.849 26.9489Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5821 18.3512C72.5836 18.3512 74.201 18.9847 75.4343 20.2517C76.6676 21.4987 77.2842 23.2484 77.2842 25.5009V35.3054H73.0385V26.0741C73.0385 24.7467 72.7049 23.7311 72.0377 23.0272C71.3706 22.3031 70.4608 21.9411 69.3083 21.9411C68.1357 21.9411 67.2057 22.3031 66.5183 23.0272C65.8511 23.7311 65.5175 24.7467 65.5175 26.0741V35.3054H61.2718V18.5925H65.5175V20.6741C66.0836 19.95 66.8013 19.3869 67.6707 18.9847C68.5603 18.5623 69.5307 18.3512 70.5821 18.3512Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2688 35.3054L85.5674 28.1858V35.3054H81.3217V12.9813H85.5674V25.6819L91.2082 18.5925H96.7276L89.3279 26.9791L96.7883 35.3054H91.2688Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.185 16.6014C100.437 16.6014 99.8104 16.3702 99.3049 15.9076C98.8197 15.4249 98.5771 14.8316 98.5771 14.1277C98.5771 13.4238 98.8197 12.8405 99.3049 12.378C99.8104 11.8953 100.437 11.6539 101.185 11.6539C101.933 11.6539 102.55 11.8953 103.035 12.378C103.541 12.8405 103.793 13.4238 103.793 14.1277C103.793 14.8316 103.541 15.4249 103.035 15.9076C102.55 16.3702 101.933 16.6014 101.185 16.6014ZM103.278 18.5925V35.3054H99.032V18.5925H103.278Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.175 22.0618H112.234V35.3054H107.927V22.0618H106.017V18.5925H107.927V17.7478C107.927 15.6964 108.514 14.188 109.686 13.2227C110.859 12.2573 112.628 11.8048 114.994 11.8651V15.4249C113.962 15.4048 113.245 15.5757 112.84 15.9377C112.436 16.2998 112.234 16.9534 112.234 17.8986V18.5925H115.175V22.0618Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M134 18.5925L123.598 43.2093H119.079L122.719 34.883L115.986 18.5925H120.747L125.084 30.2674L129.481 18.5925H134Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1056_14460",
    x1: 67,
    y1: 0,
    x2: 67,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF036D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1056_14460",
    x1: 67,
    y1: 0,
    x2: 67,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF008A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65626,
    stopColor: "#EF0065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF008A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1056_14460",
    x1: 67,
    y1: 0,
    x2: 67,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B53FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#4EBCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535AFD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1056_14460",
    x1: 67,
    y1: 0,
    x2: 67,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B53FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#4EBCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535AFD",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankify);
export default __webpack_public_path__ + "static/media/rankify.27c3b2cc6fa3d46d9f54d46a5e563a0d.svg";
export { ForwardRef as ReactComponent };